'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/seller.ts
var SELLER_QUERY = `
id
title
href
logo{${IMAGE_QUERY}}
`;

export {
  SELLER_QUERY
};
//# sourceMappingURL=chunk-AHEYDCQX.mjs.map